export const stakingAddress = "0x20308261a5CC45521810a67c3DD349bF99A87be4";
export const tokenAddress = "0xc54abea15CFd8c669861e03995835961aEA27cCA";
